import { useEffect, useState } from 'react';
import { fetchDeviceData } from '../Api/DevicesApi';

export function useDeviceInfo(deviceId, alertInfo) {
    const [deviceInfo, setDeviceInfo] = useState(null);

    useEffect(() => {
        if (!deviceId) return;
        (async () => {
            const device = await fetchDeviceData(deviceId);
            const { address, device: meter, device_iot: deviceIot, time_data: timeData, data, paid_info: paidInfo, data: liveData } = device;
            const addressString = [
                address[0].city,
                address[0].street,
                address[0].building,
                device.address_number
            ].filter(item => item && item.toString().trim() !== '').join(', ');

            setDeviceInfo({
                user: {
                    ownership: paidInfo.ownership,
                    address: addressString,
                },
                device: {
                    'Тип счетчика': meter.dev_type,
                    'Заводской номер': meter.dev_number,
                    'Тип ресурса': meter.resourse_type,
                    'Марка': meter.brand,
                    'Диаметр (корпус)': meter.diameter_body,
                    'Место установки': meter.commit,
                    'Дата окончания поверки': !meter.verification_end_date
                        ? ''
                        : new Date(meter.verification_end_date * 1000).toLocaleDateString('ru-RU'),
                    'Множитель': meter.factor,
                    'Начальне показания': ((liveData.start_volume ?? 0) * (meter.factor ?? 1)).toFixed(3)
                        + `${meter.dev_type === 'ВС' ? ' м³' : meter.dev_type === 'ТС' ? ' ГДж' : meter.dev_type === 'ГС' ? ' м³' :' кВт-Ч'}`
                },
                deviceIoT: {
                    'Тип устройства': deviceIot.dev_type_iot,
                    'Марка': deviceIot.brand_iot,
                    'Серийный номер': deviceIot.module_number,
                    'Токен': deviceIot.token,
                    'Производитель': deviceIot.manufacture,
                },
                paidInfo: {
                    'Лицевой счет': paidInfo.accountnumber,
                    'Абонентский район': paidInfo.subscriptionarea,
                    'Реестр': paidInfo.registry,
                    'Код прибора в ЕРИП': paidInfo.devicecode,
                    'Владелец': paidInfo.ownership,
                },
                status: device.data.status,
                group: device.group,
                addressId: device.address[0]._id,
                addressNumber: device.address_number
            });
        })();
    }, [deviceId, alertInfo]);

    return deviceInfo;
}


